module.exports = __webpack_public_path__ + "static/media/la-skyline.f40a5974.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/la-skyline.jpg
// module id = 406
// module chunks = 0